
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'pricing-pages-ui',
  currentProjectVersion: 'static-1.38477',
  depVersions: {
  "pricing-pages-ui": "static-1.38477",
  "apollo-dlb": "static-3.41",
  "client-types": "static-1.372",
  "data-fetching-client": "static-1.8324",
  "demographics-service-types": "static-1.541",
  "eligibility-engine-service-types": "static-1.2073",
  "feature-store-service-types": "static-1.3384",
  "foundations-assets": "static-1.3617",
  "graphql": "static-1.58",
  "growth-monetization-service-types": "static-1.3391",
  "head-dlb": "static-1.3911",
  "history": "static-4.47",
  "hs-test-utils": "static-1.6695",
  "hub-http": "static-1.4807",
  "hubspot-dlb": "static-2.1406",
  "HubStyleTokens": "static-2.10196",
  "I18n": "static-7.1382",
  "jasmine": "static-4.3043",
  "jasmine-runner": "static-1.5109",
  "laboratory-lib": "static-3.5954",
  "personalization-service-types": "static-1.1894",
  "pricing-pages-api": "static-1.7369",
  "pricing-pages-lib": "static-1.28187",
  "purchase-motions-components": "static-1.3842",
  "quartz": "static-1.5457",
  "react-dlb": "static-1.51",
  "react-rhumb": "static-1.15288",
  "react-router-dom": "static-5.26",
  "rpc-client-utils": "static-1.3420",
  "sanitize-text": "static-1.6882",
  "self-service-api": "static-1.8899",
  "signup-constants": "static-1.16010",
  "styled-components": "static-2.64",
  "trials-service-types": "static-1.2792",
  "ui-addon-upgrades": "static-9.15900",
  "upgrade-management-service-types": "static-1.3375",
  "usage-tracker-container": "static-1.6155",
  "webpack-env": "static-1.54",
  "account-and-billing-fintech-outages": "static-3.15038",
  "copilot-toolkit": "static-1.5922",
  "demographics-client": "static-1.4115",
  "enviro": "static-4.300",
  "foundations-components": "static-1.5883",
  "foundations-theming": "static-1.3015",
  "growth-payments-core": "static-1.20813",
  "hubspot-url-utils": "static-1.3063",
  "js-cookie": "static-1.18",
  "metrics-js": "static-1.8459",
  "onboarding-scopes": "static-1.5258",
  "payments-enrollment-embed-lib": "static-1.17320",
  "PortalIdParser": "static-2.278",
  "prefetcher": "static-1.4481",
  "pricing-pages-ui-components": "static-1.7507",
  "quartz-core": "static-1.4676",
  "quick-fetch": "static-1.2772",
  "raven": "static-3.4646",
  "react": "static-7.151",
  "react-redux": "static-7.16",
  "react-utils": "static-2.4233",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "SharedI18nStrings": "static-1.162",
  "signup-ui-url-generator": "static-2.6751",
  "touchless-buying-components": "static-1.3162",
  "transmute": "static-2.29",
  "trial-components-library": "static-1.10754",
  "ui-addon-i18n": "static-1.9628",
  "ui-addon-iframeable": "static-1.7592",
  "ui-addon-react-router-dom": "static-1.8314",
  "ui-addon-video-player": "static-1.7467",
  "UIComponents": "static-3.7144",
  "usage-tracker-core": "static-1.6015",
  "usage-tracker-multi": "static-1.4579",
  "apollo-stack-hubspot": "static-3.43",
  "hs-promise-rejection-tracking": "static-1.4190",
  "raven-hubspot": "static-1.4953",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "bend-plugin-trellis-migration": "static-1.2359",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.1734",
  "quartz-webpack": "static-1.1681",
  "msw": "static-1.39",
  "ts-schema": "static-1.3043",
  "hs-story-utils": "static-1.8098",
  "HeadJS": "static-2.569",
  "framer-motion": "static-1.40",
  "hs-test-utils-bend-plugin": "static-1.1806",
  "testing-library": "static-1.120",
  "i18n-data": "static-1.196",
  "moment-timezone": "static-5.51",
  "superstore": "static-1.3473",
  "marketing-contacts-client": "static-1.6339",
  "nav-client-types": "static-1.1105",
  "purchase-motions-api": "static-1.3844",
  "usage-tracker": "static-1.6165",
  "quartz-core-utils": "static-1.2324",
  "StyleGuideUI": "static-3.455",
  "autolinker": "static-3.11",
  "sanitize": "static-1.3088",
  "csstype": "static-1.38",
  "atom": "static-1.3923",
  "cssUtils": "static-1.472",
  "HubStyle": "static-2.10505",
  "icons": "static-2.591",
  "react-input-autosize": "static-2.17",
  "salesImages": "static-1.498",
  "chatspot-client-types": "static-1.8407",
  "chatspot-core": "static-1.15122",
  "bend-plugin-foundations-components": "static-1.2151",
  "floating-ui": "static-1.28",
  "foundations-theming-specialty": "static-1.732",
  "react-aria": "static-1.38",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.73",
  "tanstack-table": "static-1.23",
  "ui-fonts": "static-1.331",
  "ui-images": "static-2.811",
  "bend-plugin-foundations-theming": "static-1.1498",
  "foundations-theming-base": "static-1.2000",
  "commerce-analytics-service-client": "static-1.2423",
  "frontend-preferences-client": "static-1.6575",
  "hs-lodash": "static-4.45",
  "ui-addon-opt": "static-4.7350",
  "crm_data": "static-4.86379",
  "customer-data-objects-ui-components": "static-1.11589",
  "growth-onboarding-confetti": "static-1.1811",
  "growth-onboarding-feedback-components": "static-1.5153",
  "growth-onboarding-reliability": "static-1.3861",
  "marketplace-ui-apps-core": "static-1.12302",
  "onboarding-tours": "static-1.14069",
  "stripe-embedded-components": "static-1.5088",
  "dispatcher": "static-1.111",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.641",
  "hub-http-shared-msw-handlers": "static-1.6950",
  "hubspotter-http": "static-1.3496",
  "hubspotter-http-shared-msw-handlers": "static-1.6948",
  "mobile-manifest-mixins": "static-1.340",
  "platform-navigation-bootstrap": "static-1.11112",
  "immer": "static-1.33",
  "checkout-sdk": "static-3.20854",
  "checkout-service-types": "static-1.2844",
  "company-details-components": "static-1.4614",
  "emoji-regex": "static-1.7",
  "foundations-components-test-utils": "static-1.3368",
  "payment-method-components": "static-1.5249",
  "upgrade-catalog-service-types": "static-1.2577",
  "ai-components-ui-library": "static-1.5074",
  "hs-promise-utils": "static-1.4229",
  "hubs-service-types": "static-1.163",
  "user-context": "static-1.3872",
  "magpie-lib": "static-1.4373",
  "navigation-messaging": "static-1.2984",
  "usage-tracker-anonymous": "static-1.4582",
  "usage-tracker-public": "static-1.5976",
  "sassPrefix": "static-1.130",
  "feedback-loader": "static-1.26398",
  "crm_schema": "static-3.86416",
  "crm_universal": "static-1.20449",
  "customer-data-email": "static-1.15649",
  "customer-data-objects": "static-1.6315",
  "customer-data-ui-utilities": "static-1.8431",
  "native-integrations-shared-strings": "static-1.6536",
  "property-translator": "static-1.4092",
  "avatar-components": "static-1.1123",
  "react-immutable-proptypes": "static-2.8",
  "reference-resolvers": "static-1.6855",
  "ui-addon-avatars": "static-2.8133",
  "developer-experience-shared-components": "static-1.8793",
  "immutable-less": "static-1.3262",
  "marketplace-ui-client-types": "static-1.11172",
  "marketplace-ui-common": "static-1.13766",
  "ui-addon-integrations-directory-panel": "static-2.6692",
  "ui-extensibility-client-types": "static-1.2874",
  "ui-universal-auth": "static-1.7494",
  "getting-started-shared-tasks": "static-1.11922",
  "growth-data-modal": "static-1.3914",
  "navigation-components": "static-1.13657",
  "ui-shepherd-react": "static-3.8756",
  "ui-shepherd-tracker": "static-1.6137",
  "stripe-connect-js": "static-1.39",
  "platform-infra-nav-components": "static-1.6601",
  "hub-http-rxjs": "static-1.608",
  "normalizr": "static-3.9",
  "PatternValidationJS": "static-1.437",
  "ramda": "static-1.7",
  "rxjs": "static-5.10",
  "company-details-service-types": "static-1.2630",
  "final-form": "static-1.39",
  "billing-payments-client-types": "static-1.2767",
  "ContentUtils": "static-1.62832",
  "getting-started-shared-tasks-store": "static-1.11040",
  "idb-keyval": "static-1.20",
  "magpie-types": "static-1.3833",
  "simple-logging-lib": "static-1.1738",
  "FormUrlGenerator": "static-2.3424",
  "apollo-link-hub-http": "static-2.3490",
  "FileManagerCore": "static-1.33591",
  "FileManagerLib": "static-1.33732",
  "hubspot-apollo-client": "static-1.3531",
  "react-immutable-render-mixin": "static-1.9",
  "timezone-utils": "static-2.3951",
  "ui-gdpr-components": "static-1.8950",
  "react-dnd-compat": "static-1.3359",
  "apps-service-types": "static-1.2816",
  "oauth-service-types": "static-1.2996",
  "nav-meta": "static-1.25294",
  "react-window": "static-1.13",
  "cms-field-types": "static-1.3490",
  "content-icons-ui": "static-1.1869",
  "underscore": "static-1.8",
  "audio-components": "static-1.4339",
  "cropperjs": "static-1.10",
  "file-manager-components": "static-1.18091",
  "FileManagerImages": "static-1.31242",
  "urlinator": "static-1.3253",
  "video-components": "static-1.7433",
  "video-data-lib": "static-1.29081",
  "video-embed": "static-1.29922",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "content-assistance-lib": "static-1.6187",
  "media-bridge-lib": "static-1.16562",
  "immerable": "static-1.2856",
  "social-insights-client-types": "static-1.17484",
  "outpost": "static-1.3052",
  "react-transition-group": "static-1.7",
  "ui-coaching-tips": "static-1.22337"
},
  depPathPrefixes: {
  "pricing-pages-ui": "/pricing-pages-ui/static-1.38477",
  "apollo-dlb": "/apollo-dlb/static-3.41",
  "client-types": "/client-types/static-1.372",
  "data-fetching-client": "/data-fetching-client/static-1.8324",
  "demographics-service-types": "/demographics-service-types/static-1.541",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2073",
  "feature-store-service-types": "/feature-store-service-types/static-1.3384",
  "foundations-assets": "/foundations-assets/static-1.3617",
  "graphql": "/graphql/static-1.58",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3391",
  "head-dlb": "/head-dlb/static-1.3911",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.6695",
  "hub-http": "/hub-http/static-1.4807",
  "hubspot-dlb": "/hubspot-dlb/static-2.1406",
  "HubStyleTokens": "/HubStyleTokens/static-2.10196",
  "I18n": "/I18n/static-7.1382",
  "jasmine": "/jasmine/static-4.3043",
  "jasmine-runner": "/jasmine-runner/static-1.5109",
  "laboratory-lib": "/laboratory-lib/static-3.5954",
  "personalization-service-types": "/personalization-service-types/static-1.1894",
  "pricing-pages-api": "/pricing-pages-api/static-1.7369",
  "pricing-pages-lib": "/pricing-pages-lib/static-1.28187",
  "purchase-motions-components": "/purchase-motions-components/static-1.3842",
  "quartz": "/quartz/static-1.5457",
  "react-dlb": "/react-dlb/static-1.51",
  "react-rhumb": "/react-rhumb/static-1.15288",
  "react-router-dom": "/react-router-dom/static-5.26",
  "rpc-client-utils": "/rpc-client-utils/static-1.3420",
  "sanitize-text": "/sanitize-text/static-1.6882",
  "self-service-api": "/self-service-api/static-1.8899",
  "signup-constants": "/signup-constants/static-1.16010",
  "styled-components": "/styled-components/static-2.64",
  "trials-service-types": "/trials-service-types/static-1.2792",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.15900",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3375",
  "usage-tracker-container": "/usage-tracker-container/static-1.6155",
  "webpack-env": "/webpack-env/static-1.54",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.15038",
  "copilot-toolkit": "/copilot-toolkit/static-1.5922",
  "demographics-client": "/demographics-client/static-1.4115",
  "enviro": "/enviro/static-4.300",
  "foundations-components": "/foundations-components/static-1.5883",
  "foundations-theming": "/foundations-theming/static-1.3015",
  "growth-payments-core": "/growth-payments-core/static-1.20813",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3063",
  "js-cookie": "/js-cookie/static-1.18",
  "metrics-js": "/metrics-js/static-1.8459",
  "onboarding-scopes": "/onboarding-scopes/static-1.5258",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.17320",
  "PortalIdParser": "/PortalIdParser/static-2.278",
  "prefetcher": "/prefetcher/static-1.4481",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.7507",
  "quartz-core": "/quartz-core/static-1.4676",
  "quick-fetch": "/quick-fetch/static-1.2772",
  "raven": "/raven/static-3.4646",
  "react": "/react/static-7.151",
  "react-redux": "/react-redux/static-7.16",
  "react-utils": "/react-utils/static-2.4233",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.6751",
  "touchless-buying-components": "/touchless-buying-components/static-1.3162",
  "transmute": "/transmute/static-2.29",
  "trial-components-library": "/trial-components-library/static-1.10754",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.9628",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7592",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8314",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.7467",
  "UIComponents": "/UIComponents/static-3.7144",
  "usage-tracker-core": "/usage-tracker-core/static-1.6015",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.4579",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4190",
  "raven-hubspot": "/raven-hubspot/static-1.4953",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2359",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.1734",
  "quartz-webpack": "/quartz-webpack/static-1.1681",
  "msw": "/msw/static-1.39",
  "ts-schema": "/ts-schema/static-1.3043",
  "hs-story-utils": "/hs-story-utils/static-1.8098",
  "HeadJS": "/HeadJS/static-2.569",
  "framer-motion": "/framer-motion/static-1.40",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1806",
  "testing-library": "/testing-library/static-1.120",
  "i18n-data": "/i18n-data/static-1.196",
  "moment-timezone": "/moment-timezone/static-5.51",
  "superstore": "/superstore/static-1.3473",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.6339",
  "nav-client-types": "/nav-client-types/static-1.1105",
  "purchase-motions-api": "/purchase-motions-api/static-1.3844",
  "usage-tracker": "/usage-tracker/static-1.6165",
  "quartz-core-utils": "/quartz-core-utils/static-1.2324",
  "StyleGuideUI": "/StyleGuideUI/static-3.455",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.3088",
  "csstype": "/csstype/static-1.38",
  "atom": "/atom/static-1.3923",
  "cssUtils": "/cssUtils/static-1.472",
  "HubStyle": "/HubStyle/static-2.10505",
  "icons": "/icons/static-2.591",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "salesImages": "/salesImages/static-1.498",
  "chatspot-client-types": "/chatspot-client-types/static-1.8407",
  "chatspot-core": "/chatspot-core/static-1.15122",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2151",
  "floating-ui": "/floating-ui/static-1.28",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.732",
  "react-aria": "/react-aria/static-1.38",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.73",
  "tanstack-table": "/tanstack-table/static-1.23",
  "ui-fonts": "/ui-fonts/static-1.331",
  "ui-images": "/ui-images/static-2.811",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1498",
  "foundations-theming-base": "/foundations-theming-base/static-1.2000",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2423",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.6575",
  "hs-lodash": "/hs-lodash/static-4.45",
  "ui-addon-opt": "/ui-addon-opt/static-4.7350",
  "crm_data": "/crm_data/static-4.86379",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11589",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.1811",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5153",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.3861",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.12302",
  "onboarding-tours": "/onboarding-tours/static-1.14069",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.5088",
  "dispatcher": "/dispatcher/static-1.111",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.641",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6950",
  "hubspotter-http": "/hubspotter-http/static-1.3496",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6948",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.340",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11112",
  "immer": "/immer/static-1.33",
  "checkout-sdk": "/checkout-sdk/static-3.20854",
  "checkout-service-types": "/checkout-service-types/static-1.2844",
  "company-details-components": "/company-details-components/static-1.4614",
  "emoji-regex": "/emoji-regex/static-1.7",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3368",
  "payment-method-components": "/payment-method-components/static-1.5249",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.2577",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.5074",
  "hs-promise-utils": "/hs-promise-utils/static-1.4229",
  "hubs-service-types": "/hubs-service-types/static-1.163",
  "user-context": "/user-context/static-1.3872",
  "magpie-lib": "/magpie-lib/static-1.4373",
  "navigation-messaging": "/navigation-messaging/static-1.2984",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4582",
  "usage-tracker-public": "/usage-tracker-public/static-1.5976",
  "sassPrefix": "/sassPrefix/static-1.130",
  "feedback-loader": "/feedback-loader/static-1.26398",
  "crm_schema": "/crm_schema/static-3.86416",
  "crm_universal": "/crm_universal/static-1.20449",
  "customer-data-email": "/customer-data-email/static-1.15649",
  "customer-data-objects": "/customer-data-objects/static-1.6315",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8431",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6536",
  "property-translator": "/property-translator/static-1.4092",
  "avatar-components": "/avatar-components/static-1.1123",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reference-resolvers": "/reference-resolvers/static-1.6855",
  "ui-addon-avatars": "/ui-addon-avatars/static-2.8133",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.8793",
  "immutable-less": "/immutable-less/static-1.3262",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.11172",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.13766",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.6692",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.2874",
  "ui-universal-auth": "/ui-universal-auth/static-1.7494",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.11922",
  "growth-data-modal": "/growth-data-modal/static-1.3914",
  "navigation-components": "/navigation-components/static-1.13657",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.8756",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6137",
  "stripe-connect-js": "/stripe-connect-js/static-1.39",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6601",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.608",
  "normalizr": "/normalizr/static-3.9",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ramda": "/ramda/static-1.7",
  "rxjs": "/rxjs/static-5.10",
  "company-details-service-types": "/company-details-service-types/static-1.2630",
  "final-form": "/final-form/static-1.39",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.2767",
  "ContentUtils": "/ContentUtils/static-1.62832",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.11040",
  "idb-keyval": "/idb-keyval/static-1.20",
  "magpie-types": "/magpie-types/static-1.3833",
  "simple-logging-lib": "/simple-logging-lib/static-1.1738",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.3424",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3490",
  "FileManagerCore": "/FileManagerCore/static-1.33591",
  "FileManagerLib": "/FileManagerLib/static-1.33732",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3531",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "timezone-utils": "/timezone-utils/static-2.3951",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.8950",
  "react-dnd-compat": "/react-dnd-compat/static-1.3359",
  "apps-service-types": "/apps-service-types/static-1.2816",
  "oauth-service-types": "/oauth-service-types/static-1.2996",
  "nav-meta": "/nav-meta/static-1.25294",
  "react-window": "/react-window/static-1.13",
  "cms-field-types": "/cms-field-types/static-1.3490",
  "content-icons-ui": "/content-icons-ui/static-1.1869",
  "underscore": "/underscore/static-1.8",
  "audio-components": "/audio-components/static-1.4339",
  "cropperjs": "/cropperjs/static-1.10",
  "file-manager-components": "/file-manager-components/static-1.18091",
  "FileManagerImages": "/FileManagerImages/static-1.31242",
  "urlinator": "/urlinator/static-1.3253",
  "video-components": "/video-components/static-1.7433",
  "video-data-lib": "/video-data-lib/static-1.29081",
  "video-embed": "/video-embed/static-1.29922",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "content-assistance-lib": "/content-assistance-lib/static-1.6187",
  "media-bridge-lib": "/media-bridge-lib/static-1.16562",
  "immerable": "/immerable/static-1.2856",
  "social-insights-client-types": "/social-insights-client-types/static-1.17484",
  "outpost": "/outpost/static-1.3052",
  "react-transition-group": "/react-transition-group/static-1.7",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.22337"
}
};
